/*
 * @Author: zhao - 🍉
 * @Date: 2021-12-31 11:50:27
 * @LastEditTime: 2022-01-11 14:22:15
 * @LastEditors: zhao - 🍉
 * @Description: 平台对账
 * @FilePath: /zhzj-admin/src/page/PlatformAccountingRecord/ReconciliationList/index.jsx
 */

import { Divider, message, Popover } from 'antd';
import React, { useRef, useState, useMemo } from 'react'
import { dicPayChannel, dicPayType, liuShuiMeiJu, mapPlatformreconciliationSourceType, mapPlatformreconciliationStatus, mapPlatformreconciliationType } from '../../../axios/dictionaries';
import AuthButton from '../../../components/AuthButton/AuthButton';
import PageWrap from '../../../components/PageWrap';
import TableHelper from '../../../components/TableHelper';
import TableNewlineView from '../../../components/TableNewlineView';
import { fetchPlatformRecordList } from '../../../services/platformAccountingRecord';
import {findDict, formatTime, moneyAddComma} from '../../../utils';
import PlatformManualCheckModal from './components/ManualCheck';
import PlatformSystemCheckModal from "./components/SystemCheck";
import ReconciliationDetail from './detail';

const ReconciliationList = (props) => {
    let ReconciliationDetailRef = useRef()
    let PlatformManualCheckModalRef = useRef()
    let PlatformSystemCheckModalRef = useRef()
    let TableHelperRef = useRef()
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    
    

    const handleSingleCheck = (id) => {
        PlatformManualCheckModalRef.open([id]).then(() => {
            setSelectedRowKeys([])
            TableHelperRef.current.postDataSource()
        })
    }
    const handleSystemCheck = () => {
        PlatformSystemCheckModalRef.open().then(() => {
            TableHelperRef.current.postDataSource()
        })
    }
    const handleMultiCheck = () => {
        if (selectedRowKeys.length === 0) return message.warning('请选择至少选择一项账单')
        PlatformManualCheckModalRef.open(selectedRowKeys).then(() => {
            setSelectedRowKeys([])
            TableHelperRef.current.postDataSource()
        })
    }

    const searchOptions = useMemo(() =>[

        { key: 'shortName', type: 'input', placeholder: '商户简称' },
        { key: 'projectName', type: 'input', placeholder: '项目名' },
        { key: 'buildingName', type: 'input', placeholder: '楼盘小区名称 / 编号' },
        { key: 'customerName', type: 'input', placeholder: '租客姓名' },
        { key: 'phone', type: 'input', placeholder: '手机' },
        { key: 'roomNo', type: 'input', placeholder: '房号' },
        { key: 'reconciliationState', type: 'select', options: mapPlatformreconciliationStatus ,initialValue: "1", placeholder: '对账状态', },
        { key: 'tradeTimeStart', type: 'date', placeholder: '请选择交易开始时间',width:150, },
         { key: 'tradeTimeEnd', type: 'date', placeholder: '请选择交易截止时间',width:150 },
        { key: 'keyword', type: 'input', placeholder: '关键字' },
        { key: 'orderNoThird', type: 'input', placeholder: '他方流水号' },
        { key: 'status', type: 'select', options: liuShuiMeiJu, placeholder: '流水状态' },
        { key: 'reconciliationType', type: 'select', options: mapPlatformreconciliationType, placeholder: '对账类型' },
        { key: 'sourceType', type: 'select', options: mapPlatformreconciliationSourceType, placeholder: '流水来源' },
        { key: 'payChannel', type: 'select', options: dicPayChannel, placeholder: '支付渠道' },
        { key: 'payType', type: 'select', options: dicPayType, placeholder: '支付类别' },
        // { key: 'receiveOrPay', type: 'select', options: [{title: '收入', value:1},{title: '支付', value: 2}], placeholder: '收支类别' },

    ],[]) 


    

    const columns = useMemo(() =>[

        { title: '交易时间', dataIndex: 'tradeTime', width: 120 , render: (text) => formatTime(text, 'YYYY-MM-DD HH:mm') },
        { title: '对账状态/操作人', dataIndex: 'reconciliationState', width: 100 , render(text,record){
                return <span>
                   <div>{findDict(mapPlatformreconciliationStatus, record.reconciliationState).title}</div>
                    <div>{record.reconciliationCreateByName}</div>
                </span>
            } },
        { title: '对账类型/对账时间', dataIndex: 'reconciliationTime', width: 120 , render(text,record){
            return <span>
               <div>{findDict(mapPlatformreconciliationType, record.reconciliationType).title}</div>
                <div>{record.reconciliationTime ? formatTime(record.reconciliationTime, 'YYYY-MM-DD HH:mm') : null}</div>
            </span>
               }},
        { title: '我方流水/他方流水', dataIndex: 'orderNo', width: 235 , render: (text, record) => {
            return <TableNewlineView>{[record.orderNo, record.orderNoThird]}</TableNewlineView>
        } },
        {
            title: '交易金额 | 名称',
            dataIndex: 'amount',
            width: 200 ,
            // align: 'right',
            render(text, record, index) {
                return <span>
                <div>{record.amount ? moneyAddComma(record.amount) : null}</div>
                <div>{record.feeName}</div>
            </span>
            }
        },
        {
            title: '交易渠道 | 方式',
            width: 100 ,
            dataIndex: 'payChannels',
            render(text, record, index) {
                let now = dicPayChannel.find(item => item.value === record.payChannel);
                let nows = dicPayType.find(item => item.value === record.payType);
                if (now) {
                    return <span>
                    <div>{now ? now.title : null}</div>
                    <div>{nows ? nows.title : null}</div>
                </span>
                }
                return null
            }
        },
        {
            title: '房号',
            dataIndex: 'roomNos',
            width: 60 ,
        },
        {
            title: '租客',
            dataIndex: 'customerName',
            width: 100 ,
            render(text, record, index) {
                return <span>
                <div>{record.customerName}</div>
                <div>{record.customerPhone}</div>
            </span>
            }
        },
        {
            title: '商户 | 项目',
            dataIndex: 'mustPadyDate',
            width: 130 ,
            render(text, record, index) {
                return <span>
                <div>{record.merchantName}</div>
                <div>{record.projectName}</div>
            </span>
            }
        },
        { title: '对账操作人', dataIndex: 'reconciliationCreateByName',
            width: 80 ,},
        { title: '对账备注信息', dataIndex: 'reconciliationNote'},
        { title: '操作', dataIndex: 'actions', fixed: 'right', width: 120, render: (text, record) => {
            return <React.Fragment>
                <AuthButton authkey="e-14-1">
                    <a onClick={() =>ReconciliationDetailRef.open(record.tradeRecordId)}>详情</a>
                </AuthButton>
                <Divider type="vertical" />
                {record.reconciliationState !== 2 && (
                    <AuthButton authkey="e-14-2" type="primary" >
                        <a onClick={() => handleSingleCheck(record.tradeRecordId)}>人工对账</a>
                    </AuthButton>
                )}
            </React.Fragment>
        } },
    ],[]) 
    const rowSelection = {
        onChange: (selectedRowKeys) => {
            console.log(selectedRowKeys)
            setSelectedRowKeys(selectedRowKeys)
        },
        fixed: true,
        selectedRowKeys,
        getCheckboxProps: (record) => {
            return { disabled: record.reconciliationState === 2 }
        }
    }

   
    return (
        <PageWrap>
           
            <TableHelper 
                getRef={ref => TableHelperRef.current = ref}
                request={fetchPlatformRecordList}
                columns={columns} scroll={{x: 1700}}
                searchOptions={searchOptions}  
                tableProps={{rowSelection, rowKey: 'tradeRecordId'}}
            >
                <div style={{marginTop: 20, textAlign: 'right'}} slot="mid">
                    <AuthButton authkey="e-14-3" type="primary" onClick={handleSystemCheck}>
                        系统对账
                    </AuthButton>
                    
                    <AuthButton style={{marginLeft: 5}} authkey="e-14-4" type="primary" onClick={handleMultiCheck}>
                        手动对账
                    </AuthButton>
                </div>
            </TableHelper>

            <ReconciliationDetail getRef={ref => ReconciliationDetailRef = ref} />
            <PlatformManualCheckModal getRef={ref => PlatformManualCheckModalRef = ref} />
            <PlatformSystemCheckModal getRef={ref => PlatformSystemCheckModalRef = ref} />
        </PageWrap>
    )
}

export default ReconciliationList



// WEBPACK FOOTER //
// ./src/page/PlatformAccountingRecord/ReconciliationList/index.jsx